import type { ReactNode } from 'react'

const joinClassNames = (...classNames: Array<string | null | undefined | false>) =>
  classNames.filter(Boolean).join(' ')

type CustomerAreaSurfaceCardProps = {
  title?: string
  subtitle?: string
  actions?: ReactNode
  footer?: ReactNode
  className?: string
  contentClassName?: string
  children: ReactNode
}

export const CustomerAreaSurfaceCard = ({
  title,
  subtitle,
  actions,
  footer,
  className,
  contentClassName,
  children,
}: CustomerAreaSurfaceCardProps) => (
  <section
    className={joinClassNames(
      'ca-surface-muted ca-theme-transition px-5 py-5',
      className,
    )}
  >
    {title || subtitle || actions ? (
      <header className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          {title ? <h2 className="text-base font-semibold text-(--color-text-primary)">{title}</h2> : null}
          {subtitle ? <p className="mt-1 text-sm text-(--color-text-muted)">{subtitle}</p> : null}
        </div>
        {actions ? <div className="shrink-0">{actions}</div> : null}
      </header>
    ) : null}
    <div className={joinClassNames(title || subtitle || actions ? 'mt-4' : '', contentClassName)}>{children}</div>
    {footer ? <footer className="mt-4">{footer}</footer> : null}
  </section>
)
